<script>
    let { text, tiny = false, width = "100%", height = "100%" } = $props();
</script>

<div
    class="spinner {tiny ? '--tiny' : ''}"
    style="width: {width}; height: {height};"
>
    <span></span>
    {#if text}
        <p>{text}</p>
    {/if}
</div>

<style lang="scss">
    @use "./styles/index.scss";
</style>
